import React, { Component } from "react"

function leadZero(n) {
    return (n < 10 ? '0' : '') + n;
}

function short_months(dt) {
    Date.monthNamesShortEn = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
    ];

    return Date.monthNamesShortEn[dt.getMonth()];
}

export default class DTG extends Component {

    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        var today = new Date();
        var DD = today.getUTCDate();
        var MM = today.getUTCMonth() + 1;
        // var date = ('0' + (today.getDate())).slice(-2);
        // var month = ('0' + (today.getMonth() + 1)).slice(-2)
        var MMM = short_months(today);
        var YYYY = today.getFullYear();
        DD = leadZero(DD);

        var h = today.getUTCHours();
        var m = today.getUTCMinutes();
        var s = today.getUTCSeconds();
        h = leadZero(h);
        m = leadZero(m);
        s = leadZero(s);
        var dtg = `${DD} ${MMM} ${YYYY} ${h}:${m}:${s}Z`

        return (
            <div className="dtg">
                DTG {dtg}
            </div>
        )
    }
}